import { createFileRoute, Outlet } from "@tanstack/react-router"

import { StudioDataAccessGate } from "~/components/studio/StudioDataAccessGate"
import { useCompany } from "~/hooks/useCompany"

export const Route = createFileRoute("/_auth/insights/studio")({
  component: RouteComponent,
})

function RouteComponent() {
  const { data: company, isLoading } = useCompany()

  // Wait for company to load — otherwise we'd flash the gate before knowing the setting.
  if (isLoading || !company) return null
  if (!company.aiHakiDataAccess) return <StudioDataAccessGate />

  return <Outlet />
}
